module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/1v1.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2F1v1.jpg
// module id = 0lZU
// module chunks = 93